var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-alert',[_vm._v(" Vous n'avez pas les autorisations nécessaires pour accéder à cette page. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }